import { ReactComponent as CeillingFanImage } from "assets/images/svg/ceilling-fan.svg";
import { ReactComponent as TableFanImage } from "assets/images/svg/table-fan-icon.svg";
import { ReactComponent as GeyserImage } from "assets/images/svg/geyser-icon.svg";
import { ReactComponent as WaterHeaterImage } from "assets/images/svg/water-heater-icon.svg";
import { ReactComponent as StorageHeaterImage } from "assets/images/svg/storage-heater-icon.svg";
import { ReactComponent as WashingMachineImage } from "assets/images/svg/washing-machine-icon.svg";
import { ReactComponent as AirCoditionerImage } from "assets/images/svg/air-conditioner-icon.svg";
import { ReactComponent as AirCoolerImage } from "assets/images/svg/air-cooler-icon.svg";
import { ReactComponent as ReferigeratorImage } from "assets/images/svg/referigerator-icon.svg";
import { ReactComponent as WaterPurifierImage } from "assets/images/svg//water-purifier-icon.svg";
import { ReactComponent as VaccumeCleanerImage } from "assets/images/svg/vaccume-cleaner-icon.svg";
import { ReactComponent as ElectricKitliImage } from "assets/images/svg/kitli-icon.svg";
import { ReactComponent as HotPlateImage } from "assets/images/svg/hot-plate-icon.svg";
import { ReactComponent as ToasterImage } from "assets/images/svg/toaster-icon.svg";
import { ReactComponent as WaterPumpImage } from "assets/images/svg/water-pump-icon.svg";
import { ReactComponent as TapeRecoderImage } from "assets/images/svg/tape-recoder-icon.svg";
import { ReactComponent as TubeLightImage } from "assets/images/svg/tube-light-icon.svg";
import { ReactComponent as GharGhantiImage } from "assets/images/svg/ghar-ghanti-icon.svg";
import { ReactComponent as FlrLampImage } from "assets/images/svg/flr-lamp-icon.svg";
import styled from "@emotion/styled";

export const CeillingFanIcon = styled(CeillingFanImage)(
  ({ theme }) => `
      fill: ${theme.palette.primary.main};
      height: 20px;
      width: 20px;
  `
);

export const FlrLampIcon = styled(FlrLampImage)(
  ({ theme }) => `
      fill: ${theme.palette.primary.main};
      height: 20px;
      width: 20px;
  `
);

export const GharGhantiIcon = styled(GharGhantiImage)(
  ({ theme }) => `
      fill: ${theme.palette.primary.main};
      height: 20px;
      width: 20px;
  `
);

export const TubeLightIcon = styled(TubeLightImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const TapeRecoderIcon = styled(TapeRecoderImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const WaterPumpIcon = styled(WaterPumpImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const ToasterIcon = styled(ToasterImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const HotPlateIcon = styled(HotPlateImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const ElectricKitliIcon = styled(ElectricKitliImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const VaccumeCleanerIcon = styled(VaccumeCleanerImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const WaterPurifierIcon = styled(WaterPurifierImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const ReferigeratorIcon = styled(ReferigeratorImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const AirCoolerIcon = styled(AirCoolerImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const AirCoditionerIcon = styled(AirCoditionerImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const TableFanIcon = styled(TableFanImage)(
  ({ theme }) => `
        fill: ${theme.palette.primary.main};
        height: 20px;
        width: 20px;
    `
);

export const GeyserIcon = styled(GeyserImage)(
  ({ theme }) => `
          fill: ${theme.palette.primary.main};
          height: 20px;
          width: 20px;
      `
);

export const WaterHeaterIcon = styled(WaterHeaterImage)(
  ({ theme }) => `
            fill: ${theme.palette.primary.main};
            height: 20px;
            width: 20px;
        `
);

export const StorageHeaterIcon = styled(StorageHeaterImage)(
  ({ theme }) => `
              fill: ${theme.palette.primary.main};
              height: 20px;
              width: 20px;
          `
);

export const WashingMachineIcon = styled(WashingMachineImage)(
  ({ theme }) => `
                fill: ${theme.palette.primary.main};
                height: 20px;
                width: 20px;
            `
);
